module.exports = __webpack_public_path__ + "img/delete-minus.ba3f2cd2.svg";